interface IAchievement {
  betOption: number;
  currencyCode: string;
  currencyDecimals: number;
  denomination: number;
  lines: number;
  maxBet: number;
  minBet: number;
  rewardsLeft?: number;
  rewardsTotal?: number;
  games: { id: number; name: string }[];
  sendZero: boolean;
  progress: {
    rounds?: {
      total: number;
      current: number;
    };
    bets?: {
      current: number;
      total: number;
    };
    wins?: {
      current: number;
      total: number;
    };
  };
  reward: {
    gameName: string;
    gid: number;
    rounds: number;
    roundsLeft: number;
    wins: number | string;
    linkGame?: string;
    isAchievementBG?: boolean;
    inBonusGame?: boolean;
    isAchievementsFSandFR?: boolean;
    inFreeSpinGame?: boolean;
    id?: string;
  };
  time: {
    closedAt: string;
    finishedAt: string;
    finishedTime: string;
    stage: string;
    startedAt: string;
    startedTime: string;
  };
}

const Achievements: IAchievement = {
  betOption: 0,
  denomination: 0,
  lines: 0,
  maxBet: 0,
  minBet: 0,
  currencyCode: '',
  currencyDecimals: 0,
  rewardsLeft: 0,
  rewardsTotal: 0,
  sendZero: true,
  games: [],
  progress: {
    rounds: {
      total: 0,
      current: 0
    },
    bets: {
      current: 0,
      total: 0
    },
    wins: {
      current: 0,
      total: 0
    }
  },
  reward: {
    wins: 0,
    gid: 0,
    rounds: 0,
    roundsLeft: 0,
    gameName: '',
    linkGame: '',
    isAchievementBG: false,
    inBonusGame: false,
    isAchievementsFSandFR: false,
    inFreeSpinGame: false
  },
  time: {
    closedAt: '',
    finishedAt: '',
    finishedTime: '',
    stage: '',
    startedAt: '',
    startedTime: ''
  }
};

interface ITournament {
  id: number;
  name: string;
  stage: string;
  startedAt: string;
  finishedAt: string;
  closedAt: string;
  rules: {
    autoCharging: boolean;
    betPoints: number;
    currencyCode: string;
    currencyDecimals: number;
    games: { id: number; name: string }[];
    minBet: number;
    minRounds: number;
    prizes: { to: number; amountFS?: number; amountFSGameName?: string; from: number; amount: number }[];
    roundPoints: number;
    winPoints: number;
    winToBetPoints: number;
  };
}

const Tournament: ITournament = {
  id: 10, // id турнира
  name: '', // имя турнира
  stage: '', // состояние турнира started/finished/closing
  startedAt: '', // дата начала турнира
  finishedAt: '', // дата финиша турнира
  closedAt: '',
  rules: {
    autoCharging: false,
    currencyCode: '', // валюта турнира
    currencyDecimals: 0, // кол знаков после запятой
    games: [], // игры которые учавствуют в турннире
    minBet: 0, // мин ставка для участия в турнире
    minRounds: 0,
    prizes: [],
    roundPoints: 0,
    winPoints: 0,
    winToBetPoints: 0,
    betPoints: 0
  }
};

interface ITournamentFreeSpin {
  betOption: number;
  denomination: number;
  lines: number;
  reward: {
    granted?: boolean;
    gid: number;
    rounds: number;
    roundsLeft: number | null;
    gameName: string;
    wins: number | string;
    linkGame?: string;
  };
  sendZero: boolean;
  tournament: boolean;
  currency: string;
  currencyDecimal: number;
}

const TournamentFreeSpin: ITournamentFreeSpin = {
  betOption: 0,
  denomination: 0,
  lines: 0,
  reward: {
    granted: false,
    gid: 0,
    rounds: 0,
    roundsLeft: null,
    gameName: '',
    linkGame: '',
    wins: ''
  },
  sendZero: true,
  tournament: false,
  currency: '',
  currencyDecimal: 0
};

interface IAppConfiguration {
  uiSize: {
    landscape: {
      width: number;
      height: number;
    };
    portrait: {
      width: number;
      height: number;
    };
  };
  isMobile: boolean;
  scale: number;
  isLandscape: boolean;
  lang: string;
  platformName?: string;
  currentGid: number;
  devicePixelRatio: number;
  uiPosition?: {
    landscape: {
      panel: {
        top: number;
        left: number;
        right: number;
      };
      progress: {
        top: number;
        right: number;
      };
      menu: {
        top: number;
      };
      panelCount: {
        left: number;
        right: number;
        top: number;
        scale: number;
      };
      progressCheck: {
        top: number;
        right: number;
        left: number;
        scale: number;
      };
    };
    portrait: {
      panel: {
        top: number;
        left: number;
        bottom: number;
        right: number;
      };
      progress: {
        top: number;
        bottom: number;
        right: number;
      };
      progressCheck: {
        top: number;
        right: number;
        left: number;
        scale: number;
      };
      menu: {
        top: number;
      };
      panelCount: {
        left: number;
        right: number;
        top: number;
        scale: number;
      };
    };
    mobile: {
      landscape: {
        panelCount: {
          top: number;
        };
        progressCheck: {
          top: number;
        };
      };
    };
  };
  settings?: {
    isTournamentWinToBetForX: boolean;
  };
}

const AppConfiguration: IAppConfiguration = {
  uiSize: {
    landscape: {
      width: 1920,
      height: 1080
    },
    portrait: {
      width: 1080,
      height: 1920
    }
  },
  isMobile: true,
  scale: 1,
  isLandscape: true,
  lang: 'en',
  platformName: '',
  currentGid: 0,
  devicePixelRatio: 1,
  uiPosition: {
    landscape: {
      panel: {
        top: 400,
        left: 0,
        right: 0
      },
      menu: {
        top: 240
      },
      progress: {
        top: 0,
        right: 0
      },
      panelCount: {
        left: 0,
        right: 0,
        top: 0,
        scale: 1
      },
      progressCheck: {
        top: 0,
        right: 0,
        left: 0,
        scale: 1
      }
    },
    portrait: {
      panel: {
        top: 400,
        left: 0,
        bottom: 0,
        right: 0
      },
      progress: {
        top: 87,
        bottom: 0,
        right: 0
      },
      menu: {
        top: 240
      },
      panelCount: {
        left: 0,
        right: 0,
        top: 0,
        scale: 1
      },
      progressCheck: {
        top: 0,
        right: 0,
        left: 0,
        scale: 1
      }
    },
    mobile: {
      landscape: {
        panelCount: {
          top: 0
        },
        progressCheck: {
          top: 0
        }
      }
    }
  }
};

interface IFreeRounds {
  rounds: number;
  roundsLeft: number;
  bet: number;
  wins: number | string;
  currency: string;
  currencyDecimals: number;
  sendZero: boolean;
}

const FreeRounds: IFreeRounds = {
  rounds: 0,
  roundsLeft: 0,
  bet: 0,
  wins: 0,
  currency: '',
  currencyDecimals: 0,
  sendZero: true
};

type Currency = {
  code: string;
  decimals: number;
};

type Progress = {
  total: number;
  current: number;
};

interface IFreeBet {
  id: number;
  time: {
    startedAt: string;
    finishedAt: string;
  };
  progress: {
    rounds?: Progress;
    bets?: Progress;
  };
  info: {
    betCount: number;
    dailyPlayerLimit: number;
    distributionStatus: string;
    minBet: number;
    currency: Currency;
  };
}

interface IFreeBetSpin {
  id: number;
  freeBetId: number;
  reward: {
    win: number;
    bet: number;
    betCount: number;
  };
  time: {
    closedAt: string;
  };
  info: {
    currency: Currency;
    isArchive: boolean;
  };
}

export {
  IAchievement,
  Achievements,
  ITournament,
  Tournament,
  ITournamentFreeSpin,
  TournamentFreeSpin,
  AppConfiguration,
  IAppConfiguration,
  FreeRounds,
  IFreeRounds,
  IFreeBet,
  IFreeBetSpin
};
